import React, { useState } from 'react';

import { Typography, Grid } from '@material-ui/core';

import DialogDefault from '../components/common/DialogDefault';
import FormRegister from '../components/forms/FormRegister';
import ModalLoadingScreen from '../components/common/ModalLoadingScreen';
import BtnPrimary from '../components/common/BtnPrimary';

const PageRegister = ({ openModal, closeModal, openLoginModal }) => {
	const [openSuccessScreen, setOpenSuccessScreen] = useState(false);

	const SuccessScreen = (
		<ModalLoadingScreen
			open={openSuccessScreen}
			headline="Registierung abschließen"
			subtext="Wir haben Ihnen eine E-Mail geschickt. Bitte schließen Sie Ihre Registrierung ab."
			loadingProgress={0}
		>
			<Grid style={{ marginTop: '32px' }}>
				<BtnPrimary
					onClick={() => {
						openLoginModal(true);
						setOpenSuccessScreen(false);
					}}
				>
					Zum Login
				</BtnPrimary>
			</Grid>
		</ModalLoadingScreen>
	);

	return (
		<>
			<DialogDefault
				headline="Registrieren"
				openModal={openModal}
				closeModal={closeModal}
				showButtons={false}
			>
				<Typography>Jetzt registrieren und viele Vorteile nutzen!</Typography>
				<FormRegister
					showSuccessScreen={() => setOpenSuccessScreen(true)}
					closeRegisterModal={closeModal}
					openLoginModal={openLoginModal}
				/>
			</DialogDefault>
			{SuccessScreen}
		</>
	);
};

export default PageRegister;
